import React, { Fragment } from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import {Posts, Carousels} from '../components/Main'

import 'bootstrap/dist/css/bootstrap.min.css'

const LandingPage = () => {
    return (
        <Fragment>
            <main>
                <Carousels />

                <section>
                    <Posts sliceValue={4} trending={true} grid={true} />
                </section>

                <section>
                    <Posts
                        pageTitle={'Latest Post'}
                        sliceValue={3}
                        button={true}
                    />
                </section>

                <section>
                    <Posts
                        pageTitle={'Gallery'}
                        sliceValue={3}
                        category={['music', 'features']}
                    />
                </section>

                <section>
                    <Posts
                        pageTitle={'Gallery'}
                        sliceValue={3}
                        category={['videos', 'lifestyle']}
                    />
                </section>
            </main>
        </Fragment>
    )
}

export default ({ data, location }) => {
    // const siteTitle = data.site.siteMetadata.title

    return (
        <Layout
            location={location}
            // title={siteTitle}
        >
            <LandingPage />
        </Layout>
    )
}

export const pageQuery = graphql`
    query {
        site {
            siteMetadata {
                title
            }
        }
    }
`
